const OFFERS_GET = 'OFFERS_GET';
const OFFERS_GET_PENDING = `${OFFERS_GET}_PENDING`;
const OFFERS_GET_FAILED = `${OFFERS_GET}_FAILED`;
const OFFERS_GET_SUCCESS = `${OFFERS_GET}_SUCCESS`;

const ROUTED_APPLICATION = 'ROUTED_APPLICATION';
const ROUTED_APPLICATION_PENDING = `${ROUTED_APPLICATION}_PENDING`;
const ROUTED_APPLICATION_FAILED = `${ROUTED_APPLICATION}_FAILED`;
const ROUTED_APPLICATION_SUCCESS = `${ROUTED_APPLICATION}_SUCCESS`;

export default {
    OFFERS_GET,
    OFFERS_GET_PENDING,
    OFFERS_GET_FAILED,
    OFFERS_GET_SUCCESS,
    ROUTED_APPLICATION,
    ROUTED_APPLICATION_PENDING,
    ROUTED_APPLICATION_FAILED,
    ROUTED_APPLICATION_SUCCESS,
};